import React from 'react';
import { afterFrame } from '@elastic/apm-rum-core';

function useFinishTransactionEffect(transaction) {
  React.useEffect(function () {
    afterFrame(function () {
      transaction && transaction.detectFinish();
    });
    return function () {
      transaction && transaction.detectFinish();
    };
  }, []);
}

export { useFinishTransactionEffect };